module.exports = __webpack_public_path__ + "img/character_details.ad35bd39.png";